import { render } from "./B2B.vue?vue&type=template&id=472eee6a&scoped=true"
import script from "./B2B.vue?vue&type=script&lang=js"
export * from "./B2B.vue?vue&type=script&lang=js"

import "./B2B.vue?vue&type=style&index=0&id=472eee6a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472eee6a"]])

export default __exports__